<template>
  <section class="about-us-media text-center locked py6">
    <div class="page-container">
      <h2 class="about-us-media__title text-left mb5">
        Bravado is&nbsp;changing sales.
        <br />
        That&rsquo;s big news.
      </h2>
      <p class="about-us-media__subtitle text-left">
        Empowering
        <span>200,000+</span>
        salespeople to&nbsp;perform better has a&nbsp;way of&nbsp;turning heads. Read Bravado&rsquo;s recent appearances
        in&nbsp;the media.
      </p>
      <div class="about-us-media__cards flex flex-column justify-center">
        <BravadoCard v-for="item in medias" :key="item.color + item.title" :item="item" variant="secondary" />
      </div>
    </div>

    <div class="about-us-media__button">
      <BravadoButtonV3
        data-test="about-page-read-more-button"
        href="https://bravado.co/press-events"
        target="_blank"
        variant="secondary"
        size="lg"
      >
        <span class="px4">Bravado Press</span>
      </BravadoButtonV3>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoCard from '../../ui/BravadoItemCard.vue';
import { medias } from '../constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'AboutUsMedia',
  components: { BravadoButtonV3, BravadoCard },
  data() {
    return {
      medias,
    };
  },
});
</script>

<style lang="scss" scoped>
.about-us-media {
  margin-bottom: 50px;

  @include mq('md') {
    text-align: center;
    padding: 60px 0;
    margin-bottom: 150px;
  }

  &__title {
    //font-weight: 600;
    //font-size: 22px;
    //line-height: 28px;
    //letter-spacing: -0.5px;

    color: var(--white);

    @include mq('md') {
      //font-size: 49px;
      //line-height: 60px;
      //letter-spacing: -1.45366px;

      margin-bottom: 35px;
      text-align: center;
    }

    @include bravado-h1;
  }

  &__subtitle {
    //font-weight: 400;
    //font-size: 15px;
    //line-height: 24px;

    color: var(--gray-20);
    max-width: 660px;
    margin: 0 auto;

    @include mq('md') {
      //font-size: 20px;
      //line-height: 32px;

      text-align: center;
    }

    @include bravado-super-headline;

    span {
      color: var(--theme-purple_hc_1);
    }
  }

  &__cards {
    gap: 25px;
    padding: 50px 25px;

    @include mq('md') {
      flex-direction: row;
      gap: 25px;
      padding: 65px 0;
    }
  }

  &__button {
    position: relative;
    z-index: 1;
  }
}
</style>
